import styled from 'styled-components'

export const WarningMessage = styled.p`
  background: #fffbe6;
  border-radius: 6px;
  border: 1px solid #ffe58f;
  color: #000000cf;
  font-size: .9rem;
  font-weight: 400;
  padding: 8px;
  margin: 12px 0;
`;